import { render } from "./SliderDescriptions.vue?vue&type=template&id=fcc72688&scoped=true"
import script from "./SliderDescriptions.vue?vue&type=script&lang=js"
export * from "./SliderDescriptions.vue?vue&type=script&lang=js"

import "./SliderDescriptions.vue?vue&type=style&index=0&id=fcc72688&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcc72688"]])

export default __exports__